import { useShopExtensionQuery } from '~/api/graphql/queries/shopExtension.generated';
import { isGemXDevMode } from '~/server/auth/shopify/helpers';
import { useAppConfigStore } from '~/modules/apps/stores/app';
import { getConfig } from '~/config/environment';
import useShopStore from '~/stores/shop';
import { useState } from 'react';

const SHOPIFY_THEME_EXTENSION_ID = getConfig('APP')?.SHOPIFY_THEME_EXTENSION_ID;
const SHOPIFY_THEME_EXTENSION_HANDLE = getConfig('APP')?.SHOPIFY_THEME_EXTENSION_HANDLE;
export const useEnableThemeAppExtension = () => {
  const isShowBanner = useAppConfigStore((state) => state.isShowBanner);
  const setIsShowBanner = useAppConfigStore((state) => state.setIsShowBanner);

  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isQueryCheckState, setIsQueryCheckState] = useState<boolean>(true);

  const shopifyDomain = useShopStore((state) => state.shopInfo?.shopifyDomain);
  const shopToken = useShopStore((state) => state.shopInfo?.token);
  const extensionLink = `https://${shopifyDomain}/admin/themes/current/editor?context=apps&activateAppId=${SHOPIFY_THEME_EXTENSION_ID}/${SHOPIFY_THEME_EXTENSION_HANDLE}`;

  const onHandleEnableThemeAppExtension = () => {
    setIsLoadingButton(true);
    window.addEventListener('visibilitychange', handleCheckEnableAppExtension);
    window.open(extensionLink, '_blank');
  };

  const handleCheckEnableAppExtension = (e: Event) => {
    if (window?.document?.hidden) return;

    setIsLoadingButton(true);
    setIsQueryCheckState(true);
  };

  useShopExtensionQuery(
    {
      extensionID: SHOPIFY_THEME_EXTENSION_ID ?? '',
    },
    {
      enabled:
        !!shopToken && isQueryCheckState && (typeof isShowBanner === 'undefined' || isShowBanner),
      cacheTime: 0,
      staleTime: 0,
      onSuccess: (data) => {
        if (!isQueryCheckState) return;

        setIsQueryCheckState(false);
        setIsLoadingButton(false);

        if (isGemXDevMode()) {
          setIsShowBanner(false);
        } else {
          setIsShowBanner(!data?.shopExtension?.themeAppExtensionEnabled);
        }

        if (data?.shopExtension?.themeAppExtensionEnabled) {
          window.removeEventListener('visibilitychange', handleCheckEnableAppExtension);
        }
      },
      onError: () => {
        if (!isQueryCheckState) return;

        setIsLoadingButton(false);
        setIsQueryCheckState(false);
      },
    },
  );

  return {
    isLoadingButton,
    isShowBanner,
    setIsShowBanner,
    setIsLoadingButton,
    onHandleEnableThemeAppExtension,
  };
};
